import React, { Component } from "react";
import { getResultSpotName } from "../../util/GetResultSpotName";
import { languages } from "../../constants/languages";
// import DragIcon from "@material-ui/icons/DragHandle";
import ErrorIcon from "@material-ui/icons/Error";
import Typography from "@material-ui/core/Typography";
import EditMatchContainer from "../../containers/schedule/EditMatchContainer";
import { Droppable, Draggable } from "react-beautiful-dnd";
import Chip from "@material-ui/core/Chip";
import RefereeChip from "./RefereeChip";
import { checkRefereeWishLocation } from "../../util/CheckRefereeWishLocation";
import { checkRefereeWishDay } from "../../util/CheckRefereeWishDay";

class Match extends Component {
  state = {
    // team1: "",
    // team2: "",
    // team1Object: {},
    // team2Object: {},
    // team1Loaded: false,
    // team2Loaded: false,
    mouseOver: false,
    dialogOpen: false,
  };

  toggleDialog = () => {
    this.setState({ dialogOpen: !this.state.dialogOpen });
  };

  // UNSAFE_componentWillMount = () => {
  //   this.getTeamData();
  // };

  // getTeamData = () => {
  //   if (this.unsubscribeTeam1) {
  //     this.unsubscribeTeam1();
  //   }
  //   if (this.unsubscribeTeam2) {
  //     this.unsubscribeTeam2();
  //   }
  //   const poule = this.props.poulesByKey[this.props.match.poule] || {};
  //   let pouleKeyName = poule.fase;
  //   if (poule.bracket) {
  //     let bracket = this.props.bracketsByKey[poule.bracket] || {};
  //     pouleKeyName =
  //       poule.bracketRound === bracket.size && !bracket.subBracketTo
  //         ? poule.fase
  //         : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
  //   }
  //   const tournamentRef = window.firebase
  //     .firestore()
  //     .collection("tournaments")
  //     .doc(this.props.tournament[".key"]);

  //   this.unsubscribeTeam1 = tournamentRef
  //     .collection("teams")
  //     .where("poule" + pouleKeyName, "==", this.props.match.poule)
  //     .where("numInPoule" + pouleKeyName, "==", this.props.match.team1)
  //     .limit(1)
  //     .onSnapshot(querySnapshot => {
  //       if (querySnapshot.empty) {
  //         this.setState({ team1: "", team1Loaded: true });
  //       }
  //       querySnapshot.forEach(doc => {
  //         let team = doc.data();
  //         team["id"] = doc.id;
  //         this.setState({
  //           team1: doc.data().name,
  //           team1Loaded: true,
  //           team1Object: team
  //         });
  //       });
  //     });

  //   this.unsubscribeTeam2 = tournamentRef
  //     .collection("teams")
  //     .where("poule" + pouleKeyName, "==", this.props.match.poule)
  //     .where("numInPoule" + pouleKeyName, "==", this.props.match.team2)
  //     .limit(1)
  //     .onSnapshot(querySnapshot => {
  //       if (querySnapshot.empty) {
  //         this.setState({ team2: "", team2Loaded: true });
  //       }
  //       querySnapshot.forEach(doc => {
  //         let team = doc.data();
  //         team["id"] = doc.id;
  //         this.setState({
  //           team2: doc.data().name,
  //           team2Loaded: true,
  //           team2Object: team
  //         });
  //       });
  //     });
  // };

  // componentWillUnmount = () => {
  //   this.unsubscribeTeam1();
  //   this.unsubscribeTeam2();
  // };

  onMouseEnter = (e) => {
    this.setState({ mouseOver: true });
  };

  onMouseLeave = (e) => {
    this.setState({ mouseOver: false });
  };

  highlightTeam = (team, pouleId, secondTeam = false, teamId = null) => {
    if (teamId) {
      let teamElements = document.getElementsByClassName(
        "teamElementId" + teamId
      );
      for (let i = 0; i < teamElements.length; i++) {
        let element = teamElements[i];
        element.style.textShadow = "1px 0px 0px";
        if (secondTeam) {
          element.style.textDecoration = "underline";
        }
      }
    } else {
      let teamElements = document.getElementsByClassName(
        "teamElement" + pouleId
      );
      for (let i = 0; i < teamElements.length; i++) {
        let element = teamElements[i];
        if (element.textContent === team) {
          element.style.textShadow = "1px 0px 0px";
          if (secondTeam) {
            element.style.textDecoration = "underline";
          }
        }
      }
    }
    // let teamElementsBreak = document.getElementsByClassName("teamElementbreak");
    // for (var x = 0; x < teamElementsBreak.length; x++) {
    //   let element = teamElementsBreak[x];
    //   if (element.textContent === team) {
    //     element.style.fontWeight = "bold";
    //     if (secondTeam) {
    //       element.style.textDecoration = "underline";
    //     }
    //   }
    // }
    // let refereeElements = document.getElementsByClassName("refereeElement");
    // for (var a = 0; a < refereeElements.length; a++) {
    //   let element = refereeElements[a];
    //   if (element.textContent === team) {
    //     element.style.fontWeight = "bold";
    //     if (secondTeam) {
    //       element.style.textDecoration = "underline";
    //     }
    //   }
    // }
  };

  unHighlightTeam = (pouleId, teamId = null) => {
    if (teamId) {
      let teamElements = document.getElementsByClassName(
        "teamElementId" + teamId
      );
      // let teamElements = document.getElementsByClassName("teamElement");
      for (let i = 0; i < teamElements.length; i++) {
        let element = teamElements[i];
        element.style.textDecoration = "";
        element.style.textShadow = "";
      }
    } else {
      let teamElements = document.getElementsByClassName(
        "teamElement" + pouleId + " teamElement"
      );
      for (let i = 0; i < teamElements.length; i++) {
        let element = teamElements[i];
        element.style.textDecoration = "";
        element.style.textShadow = "";
      }
    }

    // let teamElementsBreak = document.getElementsByClassName(
    //   "teamElementbreak teamElement"
    // );
    // for (var x = 0; x < teamElementsBreak.length; x++) {
    //   let element = teamElementsBreak[x];
    //   element.style.fontWeight = "";
    //   element.style.textDecoration = "";
    // }

    // let refereeElements = document.getElementsByClassName("refereeElement");
    // for (var z = 0; z < refereeElements.length; z++) {
    //   let element = refereeElements[z];
    //   element.style.fontWeight = "";
    //   element.style.textDecoration = "";
    // }
  };

  // getRefereeDropzoneWidth = () => {
  //   let doc1 = document.getElementById(
  //     this.props.match.id + this.props.match.referee
  //   );
  //   let doc2 = document.getElementById(
  //     this.props.match.id + this.props.match.referee2
  //   );
  //   let doc3 = document.getElementById(
  //     this.props.match.id + this.props.match.referee3
  //   );
  //   let width = 0;
  //   if (doc1) {
  //     width += doc1.offsetWidth;
  //   }
  //   if (doc2) {
  //     width += doc2.offsetWidth;
  //   }
  //   if (doc3) {
  //     width += doc3.offsetWidth;
  //   }
  //   return width;
  // };

  checkOverlap = (matchStartTime, matchEndTime, t, add24) => {
    let start = t[0];
    let end = t[1];
    if (end < start) {
      // add 24 hours
      let timeSplitted = end.split(":");
      let hours = Number(timeSplitted[0] + 24).toString();
      if (matchStartTime < end) {
        // add 24 hours
        let timeSplittedEnd = matchEndTime.split(":");
        let hoursEnd = Number(timeSplittedEnd[0] + 24).toString();
        matchEndTime = hoursEnd + ":" + timeSplittedEnd[1];

        let timeSplittedStart = matchStartTime.split(":");
        let hoursStart = Number(timeSplittedStart[0] + 24).toString();
        matchStartTime = hoursStart + ":" + timeSplittedStart[1];
      }
      end = hours + ":" + timeSplitted[1];
    } else if (add24 && start < this.props.match.endTime) {
      // add 24 hours
      let timeSplitted = end.split(":");
      let hours = Number(timeSplitted[0] + 24).toString();
      end = hours + ":" + timeSplitted[1];

      let timeSplittedStart = start.split(":");
      let hoursStart = Number(timeSplittedStart[0] + 24).toString();
      start = hoursStart + ":" + timeSplittedStart[1];
    }
    return (
      (start < matchEndTime && start >= matchStartTime) ||
      (end > matchStartTime && end <= matchEndTime) ||
      (start <= matchStartTime && end >= matchEndTime)
    );
  };

  render() {
    let poule = this.props.poulesByKey[this.props.match.poule] || {};
    let hideMatch = false;
    let statusName1 = "";
    let statusName2 = "";
    if (poule["status" + this.props.match.team1]) {
      hideMatch = true;
      statusName1 =
        poule["status" + this.props.match.team1] === "bye"
          ? languages.structure.bye
          : languages.structure.noShow;
    }
    if (poule["status" + this.props.match.team2]) {
      hideMatch = true;
      statusName2 =
        poule["status" + this.props.match.team2] === "bye"
          ? languages.structure.bye
          : languages.structure.noShow;
    }
    let pouleKeyName = poule.fase;
    if (poule.bracket) {
      let bracket = this.props.bracketsByKey[poule.bracket] || {};
      pouleKeyName =
        poule.bracketRound === bracket.size && !bracket.subBracketTo
          ? poule.fase
          : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
    }

    let team1 = "";
    let team2 = "";
    let team1Object = {};
    let team2Object = {};
    if (this.props.match.team1Id) {
      team1Object = this.props.teamsByKey[this.props.match.team1Id] || {};
      team1Object["id"] = this.props.match.team1Id;
      team1 = team1Object.name || "";
    } else {
      team1Object =
        this.props.teams.find(
          (t) =>
            t["poule" + pouleKeyName] === this.props.match.poule &&
            t["numInPoule" + pouleKeyName] === this.props.match.team1
        ) || {};
      team1 = team1Object.name || "";
    }
    if (this.props.match.team2Id) {
      team2Object = this.props.teamsByKey[this.props.match.team2Id] || {};
      team2Object["id"] = this.props.match.team2Id;
      team2 = team2Object.name || "";
    } else {
      team2Object =
        this.props.teams.find(
          (t) =>
            t["poule" + pouleKeyName] === this.props.match.poule &&
            t["numInPoule" + pouleKeyName] === this.props.match.team2
        ) || {};
      team2 = team2Object.name || "";
    }

    if (team1 === "") {
      team1 =
        this.props.resultSpotsAll.filter(
          (resultSpot) =>
            resultSpot["poule" + poule.fase] === this.props.match.poule &&
            resultSpot["numInPoule" + poule.fase] === this.props.match.team1
        )[0] || "";
      if (team1 !== "") {
        team1 = getResultSpotName(
          team1,
          this.props.resultSpotsAll,
          this.props.poulesByKey,
          this.props.divisionsObject
        );
      }
    }

    if (team2 === "") {
      team2 =
        this.props.resultSpotsAll.filter(
          (resultSpot) =>
            resultSpot["poule" + poule.fase] === this.props.match.poule &&
            resultSpot["numInPoule" + poule.fase] === this.props.match.team2
        )[0] || "";
      if (team2 !== "") {
        team2 = getResultSpotName(
          team2,
          this.props.resultSpotsAll,
          this.props.poulesByKey,
          this.props.divisionsObject
        );
      }
    }
    if (team1 === "") {
      team1 =
        languages.structure.emptySpot +
        " " +
        (Number(this.props.match.team1) + 1).toString();
    }

    if (team2 === "") {
      team2 =
        languages.structure.emptySpot +
        " " +
        (Number(this.props.match.team2) + 1).toString();
    }

    // check for conflicts
    let team1Times =
      ((this.props.dividedPerPoule || {})[this.props.match.poule] || {})[
        this.props.match.team1
      ] || [];
    let team2Times =
      ((this.props.dividedPerPoule || {})[this.props.match.poule] || {})[
        this.props.match.team2
      ] || [];

    if ((this.props.dividedPerPoule || {}).events) {
      if (team1Object.id) {
        let times = this.props.dividedPerPoule.events[team1Object.id] || [];
        times.forEach((t) => {
          team1Times.push(t);
        });
      }
      if (team2Object.id) {
        let times = this.props.dividedPerPoule.events[team2Object.id] || [];
        times.forEach((t) => {
          team2Times.push(t);
        });
      }
    }
    let matchStartTime = this.props.match.startTime;
    let matchEndTime = this.props.match.endTime;
    let add24 = false;
    if (matchEndTime < matchStartTime) {
      // add 24 hours
      let timeSplitted = matchEndTime.split(":");
      let hours = Number(timeSplitted[0] + 24).toString();
      matchEndTime = hours + ":" + timeSplitted[1];
      add24 = true;
    }
    let overlapTeam1 = team1Times.filter((t) => {
      return this.checkOverlap(matchStartTime, matchEndTime, t, add24);
    });
    let overlapTeam2 = team2Times.filter((t) => {
      return this.checkOverlap(matchStartTime, matchEndTime, t, add24);
    });
    let count1 = overlapTeam1.length;
    let count2 = overlapTeam2.length;

    let ref1Times =
      (this.props.dividedRefs || {})[this.props.match.referee] || [];
    let overlapRef1 = ref1Times.filter((t) => {
      return this.checkOverlap(matchStartTime, matchEndTime, t, add24);
    });
    let countRef1 = overlapRef1.length;
    let ref2Times =
      (this.props.dividedRefs || {})[this.props.match.referee2] || [];
    let overlapRef2 = ref2Times.filter((t) => {
      return this.checkOverlap(matchStartTime, matchEndTime, t, add24);
    });
    let countRef2 = overlapRef2.length;
    let ref3Times =
      (this.props.dividedRefs || {})[this.props.match.referee3] || [];
    let overlapRef3 = ref3Times.filter((t) => {
      return this.checkOverlap(matchStartTime, matchEndTime, t, add24);
    });
    let countRef3 = overlapRef3.length;
    let ref4Times =
      (this.props.dividedRefs || {})[this.props.match.referee4] || [];
    let overlapRef4 = ref4Times.filter((t) => {
      return this.checkOverlap(matchStartTime, matchEndTime, t, add24);
    });
    let countRef4 = overlapRef4.length;
    let ref5Times =
      (this.props.dividedRefs || {})[this.props.match.referee5] || [];
    let overlapRef5 = ref5Times.filter((t) => {
      return this.checkOverlap(matchStartTime, matchEndTime, t, add24);
    });
    let countRef5 = overlapRef5.length;

    let freeRefereeSpots = false;

    let referees = [];
    if (this.props.match.referee) {
      referees.push(this.props.match.referee);
    }
    if (this.props.match.referee2) {
      referees.push(this.props.match.referee2);
    }
    if (this.props.match.referee3) {
      referees.push(this.props.match.referee3);
    }
    if (this.props.match.referee4) {
      referees.push(this.props.match.referee4);
    }
    if (this.props.match.referee5) {
      referees.push(this.props.match.referee5);
    }
    if (referees.length < 5) {
      freeRefereeSpots = true;
    }

    let refereeAlreadyInMatch =
      referees.indexOf(this.props.isDraggingReferee) !== -1 &&
      this.props.isDraggingRefereeFromMatch !== this.props.match.id;
    let isDropDisabled =
      !this.props.isDraggingReferee ||
      (!freeRefereeSpots &&
        this.props.isDraggingRefereeFromMatch !== this.props.match.id) ||
      refereeAlreadyInMatch ||
      this.props.match.field === undefined ||
      this.props.match.field === null;

    let wish = true;
    if (
      this.props.isDraggingReferee &&
      this.props.match.field !== undefined &&
      this.props.match.field !== null &&
      referees.length < 5
    ) {
      let referee =
        this.props.refereesByKey[this.props.isDraggingReferee] || {};
      let locationWish = checkRefereeWishLocation(
        referee,
        this.props.selectedSportPark
      );
      let dayWish = checkRefereeWishDay(referee, this.props.selectedDay);

      let roles = referee.roles || "all";

      let roleWish =
        roles === "all" || roles.indexOf(referees.length.toString()) !== -1;

      let team1 = team1Object || {};
      let team2 = team2Object || {};
      let teamWish =
        (referee.excludeTeams || []).indexOf(team1.id) === -1 &&
        (referee.excludeTeams || []).indexOf(team2.id) === -1;

      let teamWish2 = true;
      (referee.excludeTeams || []).forEach((tId) => {
        if (!(this.props.teamsByKey[tId] || {}).poule0) {
          teamWish2 = false;
        }
      });

      let divisions = referee.divisionsReferee || "all";

      let divisionWish =
        divisions === "all" || divisions.indexOf(poule.division) !== -1;

      let fieldWish = true;
      if (
        this.props.match &&
        this.props.match.field !== null &&
        this.props.match.field !== undefined
      ) {
        fieldWish = checkRefereeWishLocation(
          referee,
          this.props.selectedSportPark,
          this.props.match.field
        );
      }

      let timeWish = true;
      if (
        this.props.match &&
        this.props.match.field !== undefined &&
        this.props.match.field !== null &&
        this.props.startTime &&
        this.props.endTime
      ) {
        timeWish = checkRefereeWishDay(
          referee,
          this.props.selectedDay,
          this.props.startTime,
          this.props.endTime
        );
      }
      wish =
        this.props.isDraggingRefereeMaxMatchesWish &&
        locationWish &&
        dayWish &&
        roleWish &&
        teamWish &&
        teamWish2 &&
        divisionWish &&
        fieldWish &&
        timeWish;
    }

    let rootStyles = { paddingBottom: 5 };
    if (
      this.props.match.field !== undefined &&
      this.props.match.field !== null
    ) {
      rootStyles["height"] = 68;
      rootStyles["backgroundColor"] = hideMatch ? "#f5f5f5" : "";
    }

    let maxReached = false;
    let maxRefereesPerMatch = Number(
      this.props.tournament.numRefereesPerMatch || "1"
    );
    if (referees.length >= maxRefereesPerMatch) {
      maxReached = true;
    }
    return (
      <div
        className="hoverItem"
        style={rootStyles}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.state.dialogOpen ? null : this.onMouseLeave}
        id={this.props.match.id + "id"}
      >
        {true ? (
          <table
            style={{
              width: "100%",
              borderRadius: 2,
              padding: 5,
            }}
          >
            <tbody>
              <tr>
                {this.props.match.field !== undefined &&
                  this.props.match.field !== null && (
                    <td valign="top" style={{ paddingRight: 10, width: 47 }}>
                      <Typography
                        className={
                          this.props.match.duration ? "underlinedDotted" : ""
                        }
                        variant="body2"
                        // style={{
                        //   textDecoration: this.props.match.duration
                        //     ? "underline black dotted"
                        //     : "none",
                        // }}
                      >
                        {this.props.startTime}
                      </Typography>

                      {(count1 > 1 ||
                        count2 > 1 ||
                        countRef1 > 1 ||
                        countRef2 > 1 ||
                        countRef3 > 1) && (
                        <div style={{ width: "95%", textAlign: "center" }}>
                          <ErrorIcon
                            style={{
                              color: "#d50000",
                              height: 22,
                              width: 22,
                            }}
                          />
                        </div>
                      )}
                    </td>
                  )}
                <td>
                  <Typography variant="body2" style={{ marginBottom: 5 }}>
                    <span
                      className={
                        "bothTeamElement" +
                        this.props.match.poule +
                        " bothTeamElement"
                      }
                      style={{
                        color: count1 > 1 ? "#d50000" : "black",
                      }}
                      onMouseOver={() => {
                        this.highlightTeam(
                          team1,
                          this.props.match.poule,
                          false,
                          team1Object.id || null
                        );
                      }}
                      onMouseLeave={() => {
                        this.unHighlightTeam(
                          this.props.match.poule,
                          team1Object.id || null
                        );
                      }}
                    >
                      <span
                        id={this.props.match.id + "0"}
                        className={
                          "teamElement" +
                          this.props.match.poule +
                          " teamElement" +
                          (team1Object.id
                            ? " teamElementId" + team1Object.id
                            : "")
                        }
                        style={{ fontStyle: statusName1 ? "italic" : "normal" }}
                      >
                        {statusName1 ? statusName1 : team1}
                      </span>
                    </span>
                    {" - "}
                    <span
                      className={
                        "bothTeamElement" +
                        this.props.match.poule +
                        " bothTeamElement"
                      }
                      style={{
                        color: count2 > 1 ? "#d50000" : "black",
                      }}
                      onMouseOver={() => {
                        this.highlightTeam(
                          team2,
                          this.props.match.poule,
                          true,
                          team2Object.id || null
                        );
                      }}
                      onMouseLeave={() => {
                        this.unHighlightTeam(
                          this.props.match.poule,
                          team2Object.id || null
                        );
                      }}
                    >
                      <span
                        id={this.props.match.id + "1"}
                        className={
                          "teamElement" +
                          this.props.match.poule +
                          " teamElement" +
                          (team2Object.id
                            ? " teamElementId" + team2Object.id
                            : "")
                        }
                        style={{ fontStyle: statusName2 ? "italic" : "normal" }}
                      >
                        {statusName2 ? statusName2 : team2}
                      </span>
                    </span>
                  </Typography>
                  <div style={{ display: "flex" }}>
                    {/* <Typography style={{ color: "gray" }}> */}
                    <Chip
                      size="small"
                      label={poule.name}
                      style={{
                        color:
                          (
                            this.props.groupColors[
                              poule.bracket
                                ? poule.bracket
                                : this.props.match.poule
                            ] || {}
                          ).color || "white",
                        background:
                          (
                            this.props.groupColors[
                              poule.bracket
                                ? poule.bracket
                                : this.props.match.poule
                            ] || {}
                          ).background || "black",
                        marginRight: 1.5,
                      }}
                    />

                    {this.props.divisions.length > 1 && (
                      <Chip
                        size="small"
                        label={
                          (this.props.divisionsObject[poule.division] || {})
                            .name
                        }
                        style={{
                          color:
                            (this.props.divisionColors[poule.division] || {})
                              .color || "white",
                          background:
                            (this.props.divisionColors[poule.division] || {})
                              .background || "black",
                          marginRight: 1.5,
                          marginLeft: 1.5,
                        }}
                      />
                    )}
                    {/* </Typography> */}
                    <Droppable
                      droppableId={this.props.match.id}
                      type="REFEREE"
                      direction="horizontal"
                      isDropDisabled={isDropDisabled}
                    >
                      {(provided, snapshot) => {
                        return (
                          <div
                            ref={provided.innerRef}
                            style={{
                              display: "flex",
                              background:
                                !isDropDisabled && wish && !maxReached
                                  ? "#f1f1f1"
                                  : hideMatch
                                  ? "#f5f5f5"
                                  : "white",
                              borderRadius: 15,
                              height: 28,
                              minWidth: 70,
                              border:
                                !isDropDisabled && wish && !maxReached
                                  ? "1px solid green"
                                  : 0,
                              // 70 +
                              // (this.props.isDraggingReferee && !isDropDisabled
                              //   ? this.getRefereeDropzoneWidth()
                              //   : 0)
                            }}
                          >
                            {this.props.match.referee && (
                              <Draggable
                                draggableId={
                                  (
                                    this.props.refereesByKey[
                                      this.props.match.referee
                                    ] || {}
                                  ).id +
                                  this.props.match.id +
                                  "0"
                                }
                                index={0}
                                type="REFEREE"
                                isDragDisabled={
                                  this.props.tournament.scheduleLocked || false
                                }
                              >
                                {(provided, snapshot) => (
                                  <div
                                    id={
                                      this.props.match.id +
                                      this.props.match.referee
                                    }
                                  >
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <RefereeChip
                                        refereeId={this.props.match.referee}
                                        referee={
                                          this.props.refereesByKey[
                                            this.props.match.referee
                                          ] || {}
                                        }
                                        tournament={this.props.tournament}
                                        selectedSportPark={
                                          this.props.selectedSportPark || "0"
                                        }
                                        selectedDay={
                                          this.props.selectedDay || "0"
                                        }
                                        matches={this.props.allMatches || []}
                                        sportParksByKey={
                                          this.props.sportParksByKey || {}
                                        }
                                        match={this.props.match}
                                        refereeRole="0"
                                        team1={team1Object}
                                        team2={team2Object}
                                        division={poule.division}
                                        matchStartTime={this.props.startTime}
                                        matchEndTime={this.props.endTime}
                                        countRef1={countRef1}
                                        teamsByKey={this.props.teamsByKey}
                                      />
                                    </div>
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Draggable>
                            )}
                            {this.props.match.referee2 && (
                              <Draggable
                                draggableId={
                                  (
                                    this.props.refereesByKey[
                                      this.props.match.referee2
                                    ] || {}
                                  ).id +
                                  this.props.match.id +
                                  "1"
                                }
                                index={1}
                                type="REFEREE"
                                isDragDisabled={
                                  this.props.tournament.scheduleLocked || false
                                }
                              >
                                {(provided, snapshot) => (
                                  <div
                                    id={
                                      this.props.match.id +
                                      this.props.match.referee2
                                    }
                                  >
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <RefereeChip
                                        refereeId={this.props.match.referee2}
                                        referee={
                                          this.props.refereesByKey[
                                            this.props.match.referee2
                                          ] || {}
                                        }
                                        tournament={this.props.tournament}
                                        selectedSportPark={
                                          this.props.selectedSportPark || "0"
                                        }
                                        selectedDay={
                                          this.props.selectedDay || "0"
                                        }
                                        matches={this.props.allMatches || []}
                                        sportParksByKey={
                                          this.props.sportParksByKey || {}
                                        }
                                        match={this.props.match}
                                        refereeRole="1"
                                        team1={team1Object}
                                        team2={team2Object}
                                        division={poule.division}
                                        matchStartTime={this.props.startTime}
                                        matchEndTime={this.props.endTime}
                                        countRef2={countRef2}
                                        teamsByKey={this.props.teamsByKey}
                                      />
                                    </div>
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Draggable>
                            )}
                            {this.props.match.referee3 && (
                              <Draggable
                                draggableId={
                                  (
                                    this.props.refereesByKey[
                                      this.props.match.referee3
                                    ] || {}
                                  ).id +
                                  this.props.match.id +
                                  "2"
                                }
                                index={2}
                                type="REFEREE"
                                isDragDisabled={
                                  this.props.tournament.scheduleLocked || false
                                }
                              >
                                {(provided, snapshot) => (
                                  <div
                                    id={
                                      this.props.match.id +
                                      this.props.match.referee3
                                    }
                                  >
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <RefereeChip
                                        refereeId={this.props.match.referee3}
                                        referee={
                                          this.props.refereesByKey[
                                            this.props.match.referee3
                                          ] || {}
                                        }
                                        tournament={this.props.tournament}
                                        selectedSportPark={
                                          this.props.selectedSportPark || "0"
                                        }
                                        selectedDay={
                                          this.props.selectedDay || "0"
                                        }
                                        matches={this.props.allMatches || []}
                                        sportParksByKey={
                                          this.props.sportParksByKey || {}
                                        }
                                        match={this.props.match}
                                        refereeRole="2"
                                        team1={team1Object}
                                        team2={team2Object}
                                        division={poule.division}
                                        matchStartTime={this.props.startTime}
                                        matchEndTime={this.props.endTime}
                                        countRef3={countRef3}
                                        teamsByKey={this.props.teamsByKey}
                                      />
                                    </div>
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Draggable>
                            )}
                            {this.props.match.referee4 && (
                              <Draggable
                                draggableId={
                                  (
                                    this.props.refereesByKey[
                                      this.props.match.referee4
                                    ] || {}
                                  ).id +
                                  this.props.match.id +
                                  "3"
                                }
                                index={3}
                                type="REFEREE"
                                isDragDisabled={
                                  this.props.tournament.scheduleLocked || false
                                }
                              >
                                {(provided, snapshot) => (
                                  <div
                                    id={
                                      this.props.match.id +
                                      this.props.match.referee4
                                    }
                                  >
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <RefereeChip
                                        refereeId={this.props.match.referee4}
                                        referee={
                                          this.props.refereesByKey[
                                            this.props.match.referee4
                                          ] || {}
                                        }
                                        tournament={this.props.tournament}
                                        selectedSportPark={
                                          this.props.selectedSportPark || "0"
                                        }
                                        selectedDay={
                                          this.props.selectedDay || "0"
                                        }
                                        matches={this.props.allMatches || []}
                                        sportParksByKey={
                                          this.props.sportParksByKey || {}
                                        }
                                        match={this.props.match}
                                        refereeRole="3"
                                        team1={team1Object}
                                        team2={team2Object}
                                        division={poule.division}
                                        matchStartTime={this.props.startTime}
                                        matchEndTime={this.props.endTime}
                                        countRef4={countRef4}
                                        teamsByKey={this.props.teamsByKey}
                                      />
                                    </div>
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Draggable>
                            )}
                            {this.props.match.referee5 && (
                              <Draggable
                                draggableId={
                                  (
                                    this.props.refereesByKey[
                                      this.props.match.referee5
                                    ] || {}
                                  ).id +
                                  this.props.match.id +
                                  "4"
                                }
                                index={4}
                                type="REFEREE"
                                isDragDisabled={
                                  this.props.tournament.scheduleLocked || false
                                }
                              >
                                {(provided, snapshot) => (
                                  <div
                                    id={
                                      this.props.match.id +
                                      this.props.match.referee5
                                    }
                                  >
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <RefereeChip
                                        refereeId={this.props.match.referee5}
                                        referee={
                                          this.props.refereesByKey[
                                            this.props.match.referee5
                                          ] || {}
                                        }
                                        tournament={this.props.tournament}
                                        selectedSportPark={
                                          this.props.selectedSportPark || "0"
                                        }
                                        selectedDay={
                                          this.props.selectedDay || "0"
                                        }
                                        matches={this.props.allMatches || []}
                                        sportParksByKey={
                                          this.props.sportParksByKey || {}
                                        }
                                        match={this.props.match}
                                        refereeRole="4"
                                        team1={team1Object}
                                        team2={team2Object}
                                        division={poule.division}
                                        matchStartTime={this.props.startTime}
                                        matchEndTime={this.props.endTime}
                                        countRef5={countRef5}
                                        teamsByKey={this.props.teamsByKey}
                                      />
                                    </div>
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Draggable>
                            )}
                            {provided.placeholder}
                          </div>
                        );
                      }}
                    </Droppable>
                  </div>
                </td>
                {/* <td style={{ float: "right" }}>
                <DragIcon style={{ color: "gray", marginTop: 7 }} />
              </td> */}
                <td style={{ float: "right", width: 25 }}>
                  {this.state.mouseOver &&
                    this.props.match.field !== undefined &&
                    this.props.match.field !== null && (
                      <EditMatchContainer
                        match={this.props.match}
                        tournament={this.props.tournament}
                        referee={
                          this.props.refereesByKey[this.props.match.referee] ||
                          {}
                        }
                        referees={this.props.referees}
                        team1={team1}
                        team2={team2}
                        // getTeamData={this.getTeamData}
                        tournamentStatus={this.props.tournamentStatus}
                        toggleFinishedDialog={this.props.toggleFinishedDialog}
                        onMouseLeave={this.onMouseLeave}
                        toggleDialog={this.toggleDialog}
                        poulesByKey={this.props.poulesByKey}
                      />
                    )}
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <div
            style={{
              width: "100%",
              background: "white",
              borderRadius: 2,
              height: 56,
            }}
          />
        )}
      </div>
    );
  }
}

export default Match;
